module.exports = __webpack_public_path__ + "static/media/ic-menu.6926d081.svg";